export default "__VITE_ASSET__DkEg3hN3__"